import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Type, inject, input, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ENVIRONMENT, LazyModuleInjector, UserService } from '@cfp/core';
import { BuildingLayoutPageBase } from '@cfp/shared/building/layout';
import { PaybackPeriodModule } from '@cfp/ui/pipes';
import { ExcelExportModule } from '@cfp/ui/services';
import { CUSTOM_BUILDING_REPORT_CONTENT_COMPONENT } from '../consts';
import { BuildingReportContent } from './building-report-content';
import { BuildingReportProperties } from './building-report-properties';

@Component({
  selector: '<cfp-building-report',
  templateUrl: './building-report.html',
  imports: [BuildingReportContent, BuildingReportProperties, ExcelExportModule, PaybackPeriodModule, NgComponentOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildingReport extends BuildingLayoutPageBase implements OnInit {
  public readonly logoSrc = input<string>();
  public readonly showLabelInSummary = input<boolean>(true);
  public readonly showDescriptionInSummary = input<boolean>(true);
  public readonly showObjectTypeInSummary = input<boolean>(true);
  public readonly showSubObjectTypeInSummary = input<boolean>(false);
  public readonly showEnergyUsageInBusinessCase = input<boolean>(true);
  public readonly showOnlyExplanationForVisibleMeasures = input<boolean>(true);

  protected buildingPublicSharedId: string;
  protected reportCoverTitle: string;
  protected reportCoverCompany: string = '';
  protected readonly hasBuildingReportLicense = signal<boolean>(false);
  protected readonly hasRoadmapLicense = signal<boolean>(false);
  protected readonly hasBuildingReportLicenseAndModify = signal<boolean>(false);
  protected readonly hasOldBuildingReportLicenseAndModify = signal<boolean>(false);
  protected readonly isPdfServiceRequest = signal<boolean>(false);
  protected customReportContent: Type<Component> | null = null;

  protected readonly environment = inject(ENVIRONMENT);
  private readonly route = inject(ActivatedRoute);
  private readonly userService = inject(UserService);
  private readonly lazyModuleInjector = inject(LazyModuleInjector);

  constructor() {
    super();

    this.customReportContent = this.lazyModuleInjector.get(CUSTOM_BUILDING_REPORT_CONTENT_COMPONENT);
  }

  public ngOnInit(): void {
    this.isPdfServiceRequest.set(this.route.snapshot.queryParams['pdfservice'] === 'true');

    this.userService.getLicenses(true).subscribe((licenses) => {
      this.hasOldBuildingReportLicenseAndModify.set(
        licenses['building_report_old'] === true && this.userService.hasScope('buildings-report-modify')
      );

      this.hasBuildingReportLicense.set(licenses['building_report'] === true);
      this.hasBuildingReportLicenseAndModify.set(
        this.hasBuildingReportLicense() && this.userService.hasScope('buildings-report-modify')
      );
      this.hasRoadmapLicense.set(licenses['roadmap'] === true);
    });
  }
}
